import { observable, action } from "mobx";
import { IColumn, IBsInfo, IPUTAudience, IGETAudience } from "../type";
// import { actions } from '../action/action';

import {
  // handlerStartEndTim,\
  handlerIsMobile,
  handlerBrowserType,
  handlerVideoParams,
  handlerVideoPlayerOptionMp4
} from "../tool/handler";

import { handleFlash } from "global@public/tool/handleFlash";

// const ACTION = actions
const generateMixed = (n: number) => {
  const chars = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];
  let res: string = "";
  for (let i: number = 0; i < n; i++) {
    const id: number = Math.ceil(Math.random() * 35);
    res += chars[id];
  }
  return res;
};

const _random = generateMixed(32);

export class Store {
  @observable
  public liveInfo: IBsInfo; // 直播相关信息
  @observable
  public liveTime: string; //  直播时间 面板信息
  @observable
  public initData: any = {}; //  数据 - 初始数据
  @observable
  public amhere = {}; //  数据 - 播放数据
  @observable
  public voteTargetDate = {}; //  数据 - 选中投票
  @observable
  public liveId: string = ""; //  数据 - 直播Id
  @observable
  public audienceId = ""; //  数据 - 用户Id
  @observable
  public cloudMessage: any[] = []; //  聊天 - 历史信息
  @observable
  public messageValue: string = ""; //  聊天 - 发送信息
  @observable
  public allow: boolean = false; //  聊天 - 是否禁言
  @observable
  public chatRoomId: string | null = ""; //  聊天 - 房间id
  @observable
  public chatRoomName: string | null = ""; //  聊天 - 房间名称
  @observable
  public livePlayPath = ""; //  播放 - 波流地址
  @observable
  public livePlaybackPath: any = {}; //  播放 - Mp4 播放地址
  @observable
  public thumbnails: any[] = []; // 直播 - 回放
  @observable
  public playTarget: number = 0; //  播放 - 播放目标 number
  @observable
  public liveStatus = ""; //  直播 - 状态
  @observable
  public playbackStatus: boolean = false; //  直播 - 是否拥有回放
  @observable
  public playbackNames: any[] = [];
  @observable
  public isPlay: boolean = false; //  直播 - 是否播放
  @observable
  public isVerification = false; //  界面 - 是否拥有验证
  @observable
  public columnTarget = "liveInfo"; //  界面 - 初始目标
  @observable
  public feeAmount = 0; //  数据 - 收费价格
  @observable
  public isFeeLive = true; //  界面 - 是否展示免费直播
  @observable
  public _loading = true; //  界面 - loading
  @observable
  public inputWatcherInfoType: any[] = []; //  界面 - 验证渲染字段
  @observable
  public inputVerify: boolean = false; //  界面 - 提交数据验证是否通过
  @observable
  public play: any; //  播放器
  @observable
  public needPay: boolean = false; // 是否需要支付
  @observable
  public columnList: IColumn = {
    //  界面 - 展示数据
    liveInfo: "直播信息"
  };
  @observable
  public playerConfig: any;
  @observable
  public player: any;
  @observable
  public browserFlash: boolean = false;
  @observable
  public praiseCount: number = 0;
  @observable
  public userInputValues = {
    name: "",
    mobile: "",
    email: "",
    gender: "man",
    company: "",
    position: "",
    password: "",
    invitationcode: ""
  };
  @observable
  public verify: boolean = false;
  @observable
  public videoPlayerOption: any = {};

  // @observable public channels: any = {};
  @observable
  public isMp4: boolean = false;
  @observable
  public playbackIndex: number | null = null;
  @observable
  public conferenceNo: string;
  @observable
  public putInfo: any = {};

  @observable
  public xyFullScreen: boolean = true;
  public CPlayer: any;
  public isPlayerBack: boolean = false;
  public playBackArray: string[] = [];
  public randomStr = _random;
  public sendMsgState: boolean = false;
  //  界面 - 投票框
  @action
  public votePopup = (voteId: any) => {
    this.voteDataRequest(voteId);
  };

  //  数据 - 投票数据请求
  @action
  public voteDataRequest = (voteId: any) => {
    this.voteDataRequest(voteId);
  };

  //  界面 - 用户填写信息
  @action
  public userInputInfo = (e: any, target: any) => {
    this.userInputValues[target] = e.target.value;
  };

  //  数据 - 提交用户信息
  @action
  public userChangeRadio = (e: any) => {
    this.userInputValues.gender = e.target.value;
  };

  //   数据 - 提交用户信息
  @action
  public userSubmitInfo = () => {
    this.inputVerify = true;
    const putInfo: any = {};
    this.inputWatcherInfoType.map((e: any) => {
      this.submitInfoVerify(e);
      if (e === "mobile") {
        putInfo.phone = this.userInputValues[e];
      } else {
        putInfo[e] = this.userInputValues[e];
      }
    });
    console.log("inputVerify:===>>", this.liveId);
    if (this.inputVerify) {
      // ACTION.putAudience(this.liveId, putInfo);
    }
  };

  //  数据 - 提交用户信息 验证
  @action
  public submitInfoVerify = (e: any) => {
    const target =
      this.userInputValues[e] === undefined
        ? this.userInputValues[e]
        : this.userInputValues[e].trim();
    //   验证值
    switch (target) {
      case "":
      case undefined: {
        this.addError(e);
        this.inputVerify = false;
        return;
        break;
      }
    }

    //   验证 手机邮箱
    switch (e) {
      case "mobile": {
        if (!/0?(13|14|15|18)[0-9]{9}/.test(target)) {
          this.addError(e);
          this.inputVerify = false;
          return;
        }
        break;
      }

      case "email": {
        if (!/\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(target)) {
          this.addError(e);
          this.inputVerify = false;
          return;
        }
        break;
      }
    }
  };

  //   界面 - 显示错误信息

  @action
  public addError = (target: string) => {
    const Doc: Element = document.querySelector(`#${target}`) as HTMLElement;
    Doc.classList.add("input__error");
  };

  //  数据 - 播流、用户信息
  @action
  public setUserInfo = (params: IPUTAudience) => {
    this.audienceId = params.audienceId;
    this.isVerification = false;
  };

  //  audienceId
  @action
  public disposeChatPlay = (data: IGETAudience) => {
    this.amhere = data;
    this.chatRoomName = data.name;
    this.chatRoomId = data.chatRoomId;
    this.playbackNames = data.names;
    this.onChangeLiveState(data.status, data);
  };

  @action
  public onChangeLiveState = (status: string, data: any) => {
    if (status === "LIVING") {
      this.liveStatus = status;
      this.handleColumnList();
      this.handlePlay(data);
    } else {
      this.liveStatus = status;
      this.isPlay = false;
      if (!!data) {
        this.disposePlayback(data);
      }
    }
  };

  @action
  public handlePlay = (data: any) => {
    const browserType = handlerBrowserType();
    if (browserType !== "Safari" && !handleFlash() && !handlerIsMobile()) {
      this.browserFlash = true;
    }

    this.videoPlayerOption = handlerVideoParams(data.channels);
    this.isPlay = true;
  };

  //  播放 - 开始播放回放
  @action
  public beginLivePlayback = () => {
    this.isPlay = true;
    this.isPlayerBack = true;
    this.isMp4 = true;
    this.videoPlayerOption = handlerVideoPlayerOptionMp4(this.playBackArray);
  };

  @action
  public switchPlaybackPlayer = (index: number) => {
    return this.playBackArray[index];
  };

  //  播放- 处理直播回放数据
  @action
  public disposePlayback = (data: any) => {
    if (data.thumbnails !== null && data.thumbnails.length !== 0) {
      this.playbackStatus = true;
      this.handleColumnList(true);
    }
    this.thumbnails = data.thumbnails;
    this.livePlaybackPath = {
      vodInnerUrls: data.vodInnerUrls,
      vodOuterUrls: data.vodOuterUrls
    };
  };

  @action
  public handleColumnList = (playback?: boolean) => {
    if (playback) {
      this.columnList = this.initData.cdInfo.allowTalk
        ? {
            playback: "回放",
            liveInfo: "直播信息",
            chatRoom: "互动"
          }
        : {
            playback: "回放",
            liveInfo: "直播信息"
          };
    } else {
      this.columnList = this.initData.cdInfo.allowTalk
        ? {
            liveInfo: "直播信息",
            chatRoom: "互动"
          }
        : {
            liveInfo: "直播信息"
          };
    }
  };

  //   播放 - 选中目标 检测是否处于开启状态 - 替换源 ， 初始播放
  @action
  public changePlaybackTarget = (e: number) => {
    this.playTarget = e; //  切换播放目标
    if (this.isPlay) {
      this.play.load(this.livePlaybackPath.vodInnerUrls[this.playTarget]);
    } else {
      this.isPlay = true;
    }
  };

  //  聊天 - 发送内容
  @action
  public onMessageInput = (e: any) => {
    this.messageValue = e;
  };

  //  聊天 - 发送内容，添加表情
  @action
  public leanCloudOnChangeEmoji = (e: any) => {
    this.messageValue += e;
  };
}



// WEBPACK FOOTER //
// ./src/publics/store/appStore.ts